<template>
    <div class="page_container" v-loading="loading">
      <div class="add_btn_wrap">
        <el-button @click="handleClickAdd" icon="el-icon-plus" size="small" type="primary">
          新增人员
        </el-button>
      </div>
        <el-table :data="tableData" border :height="tableHeight">
            <el-table-column label="编号" prop="id" align="center" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="姓名" prop="name" align="center" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="电话" prop="phone" align="center" min-width="120" show-overflow-tooltip> </el-table-column>
          <el-table-column label="操作" align="center" width="90">
            <template slot-scope="{row}">
              <el-button type="text"  @click="handleClickDel(row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       align="right"
                       :total="pagination.total">
        </el-pagination>

      <electricChargeAdd :electricChargeVisible.sync="electricChargeVisible"  @success="getTableData"  v-if=" electricChargeVisible"/>

    </div>
</template>
<script>
    import {getTableStateHeight} from '@/utils'
    import {pagination} from '@/mixins'
    import {get798User ,del798User} from '@/api'
    import electricChargeAdd from './electricChargeAdd.vue'

    export default {
        name: 'shenlan',
        mixins: [pagination],
        components: {
          electricChargeAdd
        },
        data() {
            return {
                keyWord: '',
                tableData: [],
                tableHeight: undefined,//table高度
                loading: false,//加载动画
                resizeTimer: null, //节流定时器
                electricChargeVisible:false,

            }
        },
        mounted() {
            this.tableHeight = getTableStateHeight('page_container', 'el-form', 120)
            this.getTableData()
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    //将计算的table高度赋值给table
                    this.tableHeight = getTableStateHeight('page_container', 'el-form', 120)
                    //清除定时器
                    this.resizeTimer = null
                }, 100)
            }
        },
        methods: {

            getTableData() {
              this.loading = true
              get798User({
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        const {
                            data,
                            total
                        } = res.data
                        this.tableData = data
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            },

            handleClickAdd(){
              this.electricChargeVisible = true
            },

            handleClickDel(row){
              this.$confirm('确定移除此人员吗', '提示', {
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'error'
              }).then(() => {
                del798User({
                  uid:row.uid
                }).then(res => {
                  if (res.code === 200) {
                    this.$message.success('移除成功')
                    this.getTableData()
                  }
                })
              }).catch(() => {
                return false
              })
            },


            handleSizeChange(val) {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val
                this.getTableData()
            },

        },
    }
</script>
<style lang="scss" scoped>
.add_btn_wrap {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0 0 12px 0;
  text-align: right;
}
</style>
